// Three.js CDN version - Background animation with 3 floating bottles
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

let scene, camera, renderer, model, model02, model03;

let velocity = new THREE.Vector3(); // 移動速度
let targetPos = new THREE.Vector3();

let velocity02 = new THREE.Vector3();
let targetPos02 = new THREE.Vector3();

let velocity03 = new THREE.Vector3();
let targetPos03 = new THREE.Vector3();

// 画面内のランダム位置を取得
function getNewTarget() {
  return getRandomScreenPosition(model.position.z);
}

function getNewTarget02() {
  return getRandomScreenPosition02(model02.position.z);
}

function getNewTarget03() {
  return getRandomScreenPosition03(model03.position.z);
}

init();
animate();

function init() {
  scene = new THREE.Scene();

  camera = new THREE.PerspectiveCamera(
    30,
    window.innerWidth / window.innerHeight,
    0.1,
    100
  );
  camera.position.set(0, 1, 3);

  renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
    powerPreference: "high-performance",
  });
  renderer.setSize(window.innerWidth, window.innerHeight);
  const devicePixelRatio = Math.min(2, window.devicePixelRatio);
  renderer.setPixelRatio(devicePixelRatio);
  document.body.appendChild(renderer.domElement);

  if (window.matchMedia('(max-width: 768px)').matches) {
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
    renderer.antialias = false;
    renderer.shadowMap.enabled = false;
  }

  const pointLight01 = new THREE.PointLight(0xfff3f3, 6);
  pointLight01.position.set(0, 1, 3);
  scene.add(pointLight01);

  const ambient = new THREE.AmbientLight(0xfefefe, 2);
  scene.add(ambient);

  const loader = new GLTFLoader();

  // Get model URLs from data attributes (will be set in liquid template)
  const bgCanvas = document.querySelector('[data-bg-canvas="true"]');
  const modelRedUrl = bgCanvas?.dataset.modelRedUrl;
  const modelBlueUrl = bgCanvas?.dataset.modelBlueUrl;
  const modelYellowUrl = bgCanvas?.dataset.modelYellowUrl;

  // Load Red model
  loader.load(modelRedUrl, (gltf) => {
    model = gltf.scene;

    if (window.matchMedia('(max-width: 768px)').matches) {
      // SP
      model.scale.set(2.2, 2.1, 2.2);
    } else {
      // PC
      model.scale.set(3.3, 3.2, 3.3);
    }

    model.position.set(0, 0, 0);

    model.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;

        if (child.material.name === "cap_white") {
          child.material.transparent = false;
          child.material.color.set("#fcf8ef");
          child.material.roughness = 0.6;
          child.material.opacity = 1;
        }

        if (child.material.map) {
          // 高品質テクスチャ設定
          const tex = child.material.map;
          tex.generateMipmaps = true;
          tex.minFilter = THREE.LinearMipmapLinearFilter;
          tex.magFilter = THREE.LinearFilter;
          tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
          tex.needsUpdate = true;
        }

        if (child.name === "bottle") {
          child.material.roughness = 0.8;
        }

        if (child.name === "bottle_logo") {
          child.material.transparent = true;
          child.material.roughness = 0.4;
          child.material.opacity = 0.2;
          child.material.metalness = 0.5;
          child.material.ior = 1;
        }
      }
    });

    scene.add(model);
    targetPos.copy(getNewTarget());
  });

  // Load Blue model
  loader.load(modelBlueUrl, (gltf) => {
    model02 = gltf.scene;

    if (window.matchMedia('(max-width: 768px)').matches) {
      // SP
      model02.scale.set(2.1, 2.0, 2.1);
    } else {
      // PC
      model02.scale.set(2.8, 2.7, 2.8);
    }

    model02.position.set(0.2, 0.2, 1);

    model02.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;

        if (child.material.name === "cap_white") {
          child.material.transparent = false;
          child.material.color.set("#fcf8ef");
          child.material.roughness = 0.6;
          child.material.opacity = 1;
        }

        if (child.material.map) {
          // 高品質テクスチャ設定
          const tex = child.material.map;
          tex.generateMipmaps = true;
          tex.minFilter = THREE.LinearMipmapLinearFilter;
          tex.magFilter = THREE.LinearFilter;
          tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
          tex.needsUpdate = true;
        }

        if (child.name === "bottle") {
          child.material.roughness = 0.8;
        }

        if (child.name === "bottle_logo") {
          child.material.transparent = true;
          child.material.roughness = 0.4;
          child.material.opacity = 0.2;
          child.material.metalness = 0.5;
          child.material.ior = 1;
        }
      }
    });

    scene.add(model02);
    targetPos02.copy(getNewTarget02());
  });

  // Load Yellow model
  loader.load(modelYellowUrl, (gltf) => {
    model03 = gltf.scene;

    if (window.matchMedia('(max-width: 768px)').matches) {
      // SP
      model03.scale.set(2.1, 2.0, 2.1);
    } else {
      // PC
      model03.scale.set(3.1, 3.0, 3.1);
    }

    model03.position.set(-0.2, 0.5, -1);

    model03.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;

        if (child.material.name === "cap_white") {
          child.material.transparent = false;
          child.material.color.set("#fcf8ef");
          child.material.roughness = 0.6;
          child.material.opacity = 1;
        }

        if (child.material.map) {
          // 高品質テクスチャ設定
          const tex = child.material.map;
          tex.generateMipmaps = true;
          tex.minFilter = THREE.LinearMipmapLinearFilter;
          tex.magFilter = THREE.LinearFilter;
          tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
          tex.needsUpdate = true;
        }

        if (child.name === "bottle") {
          child.material.roughness = 0.8;
        }

        if (child.name === "bottle_logo") {
          child.material.transparent = true;
          child.material.roughness = 0.4;
          child.material.opacity = 0.2;
          child.material.metalness = 0.5;
          child.material.ior = 1;
        }
      }
    });

    scene.add(model03);
    targetPos03.copy(getNewTarget03());
  });

  window.addEventListener("resize", onResize);
}

function onResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}

// 現在の z位置で、画面内の X/Y の最大範囲を取得
function getScreenBounds(zPos) {
  const vFov = THREE.MathUtils.degToRad(camera.fov);
  const height = 2 * Math.tan(vFov / 2) * zPos;
  const width = height * camera.aspect;
  return {
    maxX: width / 2,
    maxY: height / 2,
  };
}

// 画面内のランダムな点を返す
function getRandomScreenPosition(zPos) {
  const dist = Math.abs(camera.position.z - zPos);
  const b = getScreenBounds(dist);

  return new THREE.Vector3(
    THREE.MathUtils.randFloat(-b.maxX * 0.9, b.maxX * 0.9),
    THREE.MathUtils.randFloat(-b.maxY * 0.2, b.maxY * 2.2),
    zPos
  );
}

function getRandomScreenPosition02(zPos) {
  const dist = Math.abs(camera.position.z - zPos);
  const b = getScreenBounds(dist);

  return new THREE.Vector3(
    THREE.MathUtils.randFloat(-b.maxX * 0.9, b.maxX * 0.9),
    THREE.MathUtils.randFloat(-b.maxY * 0.2, b.maxY * 2.2),
    zPos
  );
}

function getRandomScreenPosition03(zPos) {
  const dist = Math.abs(camera.position.z - zPos);
  const b = getScreenBounds(dist);

  return new THREE.Vector3(
    THREE.MathUtils.randFloat(-b.maxX * 0.8, b.maxX * 0.8),
    THREE.MathUtils.randFloat(-b.maxY * 0.2, b.maxY * 2.1),
    zPos
  );
}

// スマホではフレームレートを半分に
if (window.matchMedia('(max-width: 768px)').matches) {
  let frame = 0;

  function tick() {
    requestAnimationFrame(tick);
    frame++;

    if (frame % 2 == 0) {
      return;
    }
    renderer.render(scene, camera);
  }
  tick();
}

function animate() {
  requestAnimationFrame(animate);

  if (model) {
    // ターゲット方向ベクトル
    const dir = new THREE.Vector3().subVectors(targetPos, model.position);

    // 少し近くなったら新しいターゲットへ（止まらない！）
    if (dir.length() < 0.5) {
      targetPos.copy(getNewTarget());
    }

    // 方向を正規化
    dir.normalize();

    // 速度を少しターゲット方向に寄せる（イージング）
    velocity.lerp(dir.multiplyScalar(0.01), 0.01);

    // 位置に速度を加算（常に動く）
    model.position.add(velocity);

    // 常時ゆっくり回転
    model.rotation.y += 0.01;
    model.rotation.x += 0.01;
    model.rotation.z -= 0.01;
  }

  if (model02) {
    // ターゲット方向ベクトル
    const dir02 = new THREE.Vector3().subVectors(targetPos02, model02.position);

    // 少し近くなったら新しいターゲットへ（止まらない！）
    if (dir02.length() < 0.4) {
      targetPos02.copy(getNewTarget02());
    }

    // 方向を正規化
    dir02.normalize();

    // 速度を少しターゲット方向に寄せる（イージング）
    velocity02.lerp(dir02.multiplyScalar(0.01), 0.01);

    // 位置に速度を加算（常に動く）
    model02.position.add(velocity02);

    // 常時ゆっくり回転
    model02.rotation.y += 0.02;
    model02.rotation.x += 0.005;
    model02.rotation.z -= 0.01;
  }

  if (model03) {
    // ターゲット方向ベクトル
    const dir03 = new THREE.Vector3().subVectors(targetPos03, model03.position);

    // 少し近くなったら新しいターゲットへ（止まらない！）
    if (dir03.length() < 0.4) {
      targetPos03.copy(getNewTarget03());
    }

    // 方向を正規化
    dir03.normalize();

    // 速度を少しターゲット方向に寄せる（イージング）
    velocity03.lerp(dir03.multiplyScalar(0.01), 0.01);

    // 位置に速度を加算（常に動く）
    model03.position.add(velocity03);

    // 常時ゆっくり回転
    model03.rotation.y -= 0.01;
    model03.rotation.x += 0.01;
    model03.rotation.z -= 0.005;
  }

  renderer.render(scene, camera);
}
